import axios from 'axios';
import Auth from "./components/AuthComponent";
import Guest from "./components/GuestComponent";
import Customer from "./components/CustomerComponent";

import Wrapper from "./pages/Wrapper";

import Introduction from "./pages/Introduction";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Forgot from "./pages/auth/Forgot";
import Reset from "./pages/auth/Reset";

import Terms from "./pages/Terms";

import Welcome from "./pages/Welcome";
import Home from "./pages/Home";
import Calculator from "./pages/Calculator";
import History from "./pages/History";
import Details from "./pages/Details";
import Request from "./pages/Request";
import Result from "./pages/Result";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";
import Info from "./pages/profile/Info";
import Account from "./pages/profile/Account";
import Favorites from "./pages/profile/Favorites";
import Security from "./pages/profile/Security";
import Support from "./pages/profile/Support";
import TicketView from "./pages/admin/support/View";
import Help from "./pages/profile/Help";
import NotFound from "./pages/404";

import Partner from "./components/PartnerComponent";
import PartnerHome from "./pages/partner/Home";
import PartnerCalculator from "./pages/partner/Calculator";
import PartnerCollect from "./pages/partner/Collect";
import PartnerMovements from "./pages/partner/Movements";
import PartnerHistory from "./pages/partner/History";
import PartnerRequest from "./pages/partner/Request";
import PartnerResult from "./pages/partner/Result";
import PartnerProfile from "./pages/partner/Profile";
import PartnerCustomers from "./pages/partner/profile/Customers";
import PartnerReceivers from "./pages/partner/profile/Receivers";
import PartnerStaff from "./pages/partner/master/Staff";
import PartnerSettings from "./pages/partner/master/Settings";
import PartnerBranch from "./pages/partner/master/Branch";
import PartnerRate from "./pages/partner/master/Rate";

import Admin from "./components/AdminComponent";
import AdminHome from "./pages/admin/Home";

import CheckerPending from "./pages/admin/checker/Pending";
import CheckerApproved from "./pages/admin/checker/Approved";
import CheckerRejected from "./pages/admin/checker/Rejected";
import PayMasterPending from "./pages/admin/paymaster/Pending";
import PayMasterApproved from "./pages/admin/paymaster/Approved";
import PayMasterCompleted from "./pages/admin/paymaster/Completed";
import PayMasterRejected from "./pages/admin/paymaster/Rejected";
import PartnerBalance from "./pages/admin/checker/PartnerBalance";
import ReportGeneral from "./pages/admin/reports/General";
import ReportPending from "./pages/admin/reports/Pending";
import ReportReturns from "./pages/admin/reports/Returns";
import ReportTransbank from "./pages/admin/reports/Transbank";
import ReportBalance from "./pages/admin/reports/Balance";
import ReportPayersBalance from "./pages/admin/reports/PayersBalance";
import ReportPayersBalanceDetails from "./pages/admin/reports/PayersBalanceDetails";
import ReportInvoices from "./pages/admin/reports/Invoices";
import ReportAgente from "./pages/admin/reports/Agente";
import OpenTickets from "./pages/admin/support/Open";
import CloseTickets from "./pages/admin/support/Close";
import AdminCustomers from "./pages/admin/users/Customers";
import AdminStaff from "./pages/admin/users/Staff";
import AdminPartners from "./pages/admin/users/Partners";
import AdminCashiers from "./pages/admin/users/Cashiers";
import AdminRate from "./pages/admin/settings/Rate";
import AdminFee from "./pages/admin/settings/Fee";
import AdminLimits from "./pages/admin/settings/Limits";
import AdminWalletMonthly from "./pages/admin/WalletMonthly";
import AdminWalletDaily from "./pages/admin/WalletDaily";
import AdminPayers from "./pages/admin/settings/Payers";
import AdminPayersBanks from "./pages/admin/settings/payer/Banks";
import AdminPayersOffices from "./pages/admin/settings/payer/Offices";
import AdminIntegrations from "./pages/admin/settings/Integrations";
import AdminBankAccounts from "./pages/admin/settings/BankAccounts";
import AdminLegal from "./pages/admin/settings/Legal";
import AdminPromoCodes from "./pages/admin/settings/PromoCodes";
import ComplianceIndex from "./pages/admin/compliance/Index";
import ComplianceSenderDetail from "./pages/admin/compliance/SenderDetail";

export default [
    ...applyRules(['guest'], [
        { path: '/', name: 'Introduction', component: Introduction, meta: { title: 'Introducción' } },
        {
            path: '/', component: Auth, children:
                [
                    { path: 'login', name: 'Login', component: Login, meta: { title: 'Iniciar Sesión' } },
                    { path: 'register', name: 'Register', component: Register, meta: { title: 'Crear Cuenta' } },
                    {
                        path: 'password', component: Wrapper, children:
                            [
                                { path: '', name: 'Forgot', component: Forgot, meta: { title: 'Recuperar Contraseña' } },
                                { path: 'reset/:token', name: 'Reset', component: Reset, meta: { title: 'Cambiar Contraseña' } }
                            ]
                    }
                ]
        },
    ]),
    ...applyRules(['auth'], [
        { path: '/', redirect: { name: 'Home' } },
        { path: '/welcome', name: 'Welcome', component: Welcome, meta: { title: 'Bienvenido' } },
        {
            path: '/', component: Customer, children:
                [
                    { path: 'home', name: 'Home', component: Home, meta: { title: 'Inicio' } },
                    { path: 'calculator', name: 'Calculator', component: Calculator, meta: { title: 'Calculadora' } },
                    { path: 'history', name: 'History', component: History, meta: { title: 'Historial' } },
                    { path: 'history/details/:id', name: 'Details', component: Details, meta: { title: 'Detalles del Pago' } },
                    { path: 'request', name: 'Request', component: Request, meta: { title: 'Proceso del Pago' } },
                    { path: 'request/result', name: 'Result', component: Result, meta: { title: 'Resultado del Pago' } },
                    { path: 'notifications', name: 'Notifications', component: Notifications, meta: { title: 'Notificaciones' } },
                    { path: 'profile', name: 'Profile', component: Profile, meta: { title: 'Mi Perfil' } },
                    { path: 'profile/information', name: 'Info', component: Info, meta: { title: 'Mis Datos' } },
                    { path: 'profile/account', name: 'Account', component: Account, meta: { title: 'Mi Cuenta' } },
                    { path: 'profile/favorites', name: 'Favorites', component: Favorites, meta: { title: 'Mis Favoritos' } },
                    { path: 'profile/security', name: 'Security', component: Security, meta: { title: 'Seguridad' } },
                    { path: 'profile/support', name: 'Support', component: Support, meta: { title: 'Soporte' } },
                    { path: 'profile/support/:id/details', name: 'TicketView', component: TicketView, meta: { title: 'Detalles del Ticket' } },
                    { path: 'profile/help', name: 'Help', component: Help, meta: { title: 'Ayuda' } }
                ]
        },
        { path: '/partner', redirect: { name: 'PartnerHome' } },
        {
            path: '/partner', component: Partner, children:
                [
                    { path: 'home', name: 'PartnerHome', component: PartnerHome, meta: { title: 'Inicio' } },
                    { path: 'collect', name: 'PartnerCollect', component: PartnerCollect, meta: { title: 'Cobrar' } },
                    { path: 'calculator', name: 'PartnerCalculator', component: PartnerCalculator, meta: { title: 'Calculadora' } },
                    { 
                        path: 'request', 
                        name: 'PartnerRequest', 
                        component: PartnerRequest, 
                        meta: { title: 'Proceso del Pago' },
                        beforeEnter: async (to, from, next) => {
                            try {
                                const response = await axios.get('/api/partner/work-schedule/check');
                                if (response.data.allowed) {
                                    next();
                                } else {
                                    next({ name: 'PartnerHome' });
                                }
                            } catch (error) {
                                // En caso de error, permitir acceso por defecto
                                next();
                            }
                        }
                    },
                    { path: 'request/result', name: 'PartnerResult', component: PartnerResult, meta: { title: 'Resultado del Pago' } },
                    { path: 'notifications', name: 'PartnerNotifications', component: Notifications, meta: { title: 'Notificaciones' } },
                    { path: 'account', name: 'PartnerProfile', component: PartnerProfile, meta: { title: 'Mi Perfil' } },
                    { path: 'account/information', name: 'PartnerInfo', component: Info, meta: { title: 'Mis Datos' } },
                    { path: 'account/customers', name: 'PartnerCustomers', component: PartnerCustomers, meta: { title: 'Mis Clientes' } },
                    { path: 'account/customers/:id/receivers', name: 'PartnerReceivers', component: PartnerReceivers, meta: { title: 'Destinatarios' } },
                    { path: 'account/movements', name: 'PartnerMovements', component: PartnerMovements, meta: { title: 'Cuenta Corriente' } },
                    { path: 'account/branch', name: 'PartnerBranch', component: PartnerBranch, meta: { title: 'Sucursales' } },
                    { path: 'account/rate', name: 'PartnerRate', component: PartnerRate, meta: { title: 'Tipo de Cambio' } },
                    { path: 'account/history', name: 'PartnerHistory', component: PartnerHistory, meta: { title: 'Historial' } },
                    { path: 'account/history/details/:id', name: 'PartnerDetails', component: Details, meta: { title: 'Detalles del Pago' } },
                    { path: 'account/staff', name: 'PartnerStaff', component: PartnerStaff, meta: { title: 'Mis Cajeros' } },
                    { path: 'account/settings', name: 'PartnerSettings', component: PartnerSettings, meta: { title: 'Ajustes' } },
                    { path: 'account/security', name: 'PartnerSecurity', component: Security, meta: { title: 'Seguridad' } },
                    { path: 'account/support', name: 'PartnerSupport', component: Support, meta: { title: 'Soporte' } },
                    { path: 'account/support/:id/details', name: 'PartnerTicketView', component: TicketView, meta: { title: 'Detalles del Ticket' } },
                    { path: 'account/help', name: 'PartnerHelp', component: Help, meta: { title: 'Ayuda' } },
                ]
        },
        { path: '/admin', redirect: { name: 'AdminHome' } },
        {
            path: '/admin', component: Admin, children:
                [
                    { path: 'home', name: 'AdminHome', component: AdminHome, meta: { title: 'Inicio' } },
                    { path: 'calculator', name: 'AdminCalculator', component: Calculator, meta: { title: 'Calculadora' } },
                    { path: 'profile/information', name: 'AdminProfile', component: Info, meta: { title: 'Mi Perfil' } },
                    { path: 'profile/security', name: 'AdminSecurity', component: Security, meta: { title: 'Seguridad' } },
                    { path: 'checker/pending', name: 'CheckerPending', component: CheckerPending, meta: { title: 'Pendientes' } },
                    { path: 'checker/approved', name: 'CheckerApproved', component: CheckerApproved, meta: { title: 'Aprobadas' } },
                    { path: 'checker/rejected', name: 'CheckerRejected', component: CheckerRejected, meta: { title: 'Rechazadas' } },
                    { path: 'partner/balance', name: 'PartnerBalance', component: PartnerBalance, meta: { title: 'Prefondeo Agentes' } },
                    { path: 'paymaster/pending', name: 'PayMasterPending', component: PayMasterPending, meta: { title: 'Pendientes' } },
                    { path: 'paymaster/approved', name: 'PayMasterApproved', component: PayMasterApproved, meta: { title: 'Aprobadas' } },
                    { path: 'paymaster/completed', name: 'PayMasterCompleted', component: PayMasterCompleted, meta: { title: 'Completadas' } },
                    { path: 'paymaster/rejected', name: 'PayMasterRejected', component: PayMasterRejected, meta: { title: 'Rechazadas' } },
                    { path: 'request/:id/details', name: 'Details', component: Details, meta: { title: 'Detalles del Pago' } },
                    { path: 'reports/general', name: 'ReportGeneral', component: ReportGeneral, meta: { title: 'Reporte General' } },
                    { path: 'reports/pending', name: 'ReportPending', component: ReportPending, meta: { title: 'Reporte Pendientes' } },
                    { path: 'reports/returns', name: 'ReportReturns', component: ReportReturns, meta: { title: 'Reporte de Devoluciones' } },
                    { path: 'reports/transbank', name: 'ReportTransbak', component: ReportTransbank, meta: { title: 'Reporte Transbank' } },
                    { path: 'reports/partner/balance', name: 'ReportBalance', component: ReportBalance, meta: { title: 'Reporte Prefondeo' } },
                    { path: 'reports/payers/balance', name: 'ReportPayersBalance', component: ReportPayersBalance, meta: { title: 'Reporte Corresponsales' } },
                    { path: 'reports/payers/balance/:id', name: 'ReportPayersBalanceDetails', component: ReportPayersBalanceDetails, meta: { title: 'Reporte Prefondeo Corresponsal' } },
                    { path: 'reports/invoices', name: 'ReportInvoices', component: ReportInvoices, meta: { title: 'Reporte Facturación' } },
                    { path: 'reports/agente', name: 'ReportAgente', component: ReportAgente, meta: { title: 'Reporte Agente' } },
                    { path: 'support/:id/details', name: 'TicketView', component: TicketView, meta: { title: 'Detalles del Ticket' } },
                    { path: 'support/open', name: 'OpenTickets', component: OpenTickets, meta: { title: 'Tickets Abiertos' } },
                    { path: 'support/close', name: 'CloseTickets', component: CloseTickets, meta: { title: 'Tickets Cerrados' } },
                    { path: 'users/customers', name: 'Customers', component: AdminCustomers, meta: { title: 'Clientes' } },
                    { path: 'users/staff', name: 'Staff', component: AdminStaff, meta: { title: 'Empleados' } },
                    { path: 'users/partners', name: 'Partners', component: AdminPartners, meta: { title: 'Agentes' } },
                    { path: 'users/partners/wallet/monthly/:id', name: 'Wallet', component: AdminWalletMonthly, meta: { title: 'Cuenta Corriente - Agentes' } },
                    { path: 'users/partners/wallet/daily/:id', name: 'Wallet', component: AdminWalletDaily, meta: { title: 'Cuenta Corriente - Agentes' } },
                    { path: 'users/partners/branch/:id', name: 'Branch', component: PartnerBranch, meta: { title: 'Sucursales - Agentes' } },
                    { path: 'users/cashiers', name: 'Cashiers', component: AdminCashiers, meta: { title: 'Cajeros - Agentes' } },
                    { path: 'settings/rate', name: 'Rate', component: AdminRate, meta: { title: 'Tasa de Cambio' } },
                    { path: 'settings/fee', name: 'Fee', component: AdminFee, meta: { title: 'Tarifas' } },
                    { path: 'settings/limits', name: 'Limits', component: AdminLimits, meta: { title: 'Limites' } },
                    { path: 'settings/payers', name: 'Payers', component: AdminPayers, meta: { title: 'Pagadores' } },
                    { path: 'settings/payers/banks/:id', name: 'PayersBanks', component: AdminPayersBanks, meta: { title: 'Bancos del Pagador' } },
                    { path: 'settings/payers/offices/:id', name: 'PayersOffices', component: AdminPayersOffices, meta: { title: 'Oficinas del Pagador' } },
                    { path: 'settings/integrations', name: 'Integrations', component: AdminIntegrations, meta: { title: 'Integraciones' } },
                    { path: 'settings/bank-accounts', name: 'BankAccounts', component: AdminBankAccounts, meta: { title: 'Cuentas Bancarias' } },
                    { path: 'settings/legal', name: 'Legal', component: AdminLegal, meta: { title: 'Legal' } },
                    { path: 'settings/promo-codes', name: 'PromoCodes', component: AdminPromoCodes, meta: { title: 'Códigos Promocionales' } },
                    { path: 'compliance/alerts', name: 'ComplianceIndex', component: ComplianceIndex, meta: { title: 'Cumplimiento AML' } },
                    { path: 'compliance/sender', name: 'ComplianceSender', component: ComplianceSenderDetail, meta: { title: 'Remitente — Cumplimiento' } }
                ]
        }
    ]),
    {
        path: '/', component: Guest, children:
            [
                { path: 'terms', name: 'Terms', component: Terms, meta: { title: 'Términos & Condiciones' } },
                { path: 'calculator/guest', name: 'PublicCalculator', component: Calculator, meta: { title: 'Calculadora' } },
            ]
    },
    { path: '/ios', redirect: { path: '/' }, meta: { title: 'Inicio' } },
    { path: '/v', redirect: { path: '/' }, meta: { title: 'Inicio' } },
    { path: '/w', redirect: { name: 'PublicCalculator' }, meta: { title: 'Calculadora' } },
    { path: '*', component: NotFound, meta: { title: 'Página no Encontrada' } }
];

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {};

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = [];
        }
        routes[i].meta.rules.unshift(...rules);

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children);
        }
    }
    return routes
}
